import React from 'react';
import * as R from 'ramda';
import { connect } from 'react-redux';
import { Fragment, Link, go, push, replace, replaceRoutes } from 'redux-little-router';
import { Icon, Layout } from 'antd';
import Toolbox from '../Toolbox/Toolbox';
import Toolbar from '../components/Toolbar';
import ConnectionTool from '../Toolbox/ConnectionTool';
import Window from '../Tabs/Window';
import TabSwitcher from '../Tabs/TabSwitcher';
import logoThumb from '../assets/voicebase_thumb.svg';

const mapStateToProps = state => ({
  router: state.router,
  activeConnectionId: R.path(['connection', '/window', 'ids', '0'], state),
  loading: R.path(['connection', '/window', 'isLoading'], state),
});

const Index = ({ activeConnectionId, loading }) => {
  if (activeConnectionId !== undefined) {
    return (
      <Fragment forRoute="/">
        <Layout style={{ height: '100%' }} hasSider>
          <Toolbox />
          <Fragment forRoute="/tab">
            <Window>
              <Fragment forRoute="/:id">
                <TabSwitcher />
              </Fragment>
            </Window>
          </Fragment>
        </Layout>
      </Fragment>
    );
  }

  if (activeConnectionId === undefined && !loading) {
    return (
      <Layout style={{ height: '100%' }}>
        <Toolbar style={{ height: '100%' }}>
          <ConnectionTool title="Connections" />
        </Toolbar>
        <Layout.Content style={{ height: '100%' }}>
          <div
            style={{
              margin: '0 auto',
              marginTop: '100px',
              width: '400px',
              padding: '16px',
              borderRadius: '8px',
            }}
          >
            <div>
              <div style={{ fontSize: '24px', textAlign: 'center', color: 'rgba(0, 0, 0, 0.65)' }}>
                Welcome to our
              </div>
              <div style={{ textAlign: 'center' }}>
                <img style={{ height: '76px', verticalAlign: 'middle' }} alt="VoiceBase" src={logoThumb} />
                <span style={{ fontSize: '32px', verticalAlign: 'middle', fontWeight: 'bold' }}>Analyst Workbench</span>
              </div>
            </div>
            <div style={{ marginTop: '12px', fontSize: '16px', textAlign: 'center' }}>
              <Icon type="arrow-left" /> Create a connection to get started.
            </div>
          </div>
        </Layout.Content>
      </Layout>
    );
  }

  return (<Layout />);
};

export default connect(mapStateToProps)(Index);
